import { api } from 'utils/api'

export const loginApi = (data: { username: string; password: string }) =>
  api.post<{ access_token: string }>('auth/login', data)
